import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dataGolf = defineConnector({
  identifier: "dataGolf",
  name: "Data Golf",
  tagLine: "Golf data and predictions",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://feeds\\.datagolf\\.com/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Data Golf](https://datagolf.com/) and go to [API access](https://datagolf.com/api-access) to find your API key. API access requires a Scratch Plus membership.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Data Golf API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://feeds.datagolf.com/get-player-list?file_format=json",
  },
});
